<template>
    <div>
        <LoadingPage v-if="isLoadPage" />
        <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
        <!-- Card stats -->
        <b-row> </b-row>
        </base-header>
        <b-container fluid class="mt--7">
            <b-col lg="12">
                <card header-classes="bg-transparent">
                    <b-row class="mb-4">
                        <b-col lg="9" xl="10" md="12" class="d-flex flex-column mb-4">
                            <h2 slot="header" class="mb-0">จัดการรถ</h2>
                            <div class="text-body-1">
                                แสดงตารางรายละเอียดรถทั้งหมดที่มีอยู่
                            </div>
                        </b-col>
                        <b-col lg="3" xl="2" md="12" class="text-right">
                            <base-button type="primary" class="d-flex align-items-center" block @click="openModalCar()">
                                <b-icon icon="plus" class="mr-2"></b-icon> เพิ่มรถ
                            </base-button>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-end">
                        <b-col lg="4" md="12" class="mb-2">
                            <b-form-input
                                v-model="searchTerm"
                                placeholder="ค้นหาทะเบียนรถ"
                                @input="onSearchInput"
                            >
                            </b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col>
                            <b-table
                                responsive
                                :fields="fields"
                                :items="cars"
                                :busy="isLoading"
                            >
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    </div>
                                </template>
                                <template #cell(index)="data">
                                    {{
                                    calculateIndex(
                                        data,
                                        pagination.currentPage,
                                        pagination.perPage
                                    )
                                    }}
                                </template>
                                <template #cell(driver)="data">
                                   <div>{{ (data.item.driver) ? `${data.item.driver.firstname} ${data.item.driver.lastname}` : '-' }}</div>
                                   <small>{{ (data.item.driver) ? data.item.driver.email : '-' }}</small>
                                </template>
                                <template #cell(driver_tel)="data">
                                    {{ (data.item.driver) ? data.item.driver.phonenumber ? data.item.driver.phonenumber: '-' : '-' }}
                                </template>
                                <template #cell(status)="data">
                                    <b-badge variant="success">
                                        {{ data.item.status }}
                                    </b-badge>
                                </template>
                                <template #cell(manage)="data">
                                    <b-button
                                        variant="outline-border"
                                        size="sm"
                                        @click="
                                            $router.push({
                                                name: 'CarDetails',
                                                params: { id: data.item.id },
                                            })
                                        "
                                    >
                                        <b-icon icon="pencil-square"></b-icon>
                                    </b-button>
                                    <b-button variant="outline-danger" size="sm" @click="openModalConfirm(data.item.id)">
                                        <b-icon icon="trash-fill"></b-icon>
                                    </b-button>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="d-flex justify-content-end">
                            <b-pagination
                                v-model="pagination.currentPage"
                                :disabled="isLoading"
                                :total-rows="pagination.totalRows"
                                :per-page="pagination.perPage"
                                aria-controls="my-table"
                                class="mt-3"
                                @change="(page) => getCar(page)"
                            ></b-pagination>
                        </b-col>
                    </b-row>
                </card>
            </b-col>
            <ModalCar 
                :form="form" 
                @getCar="getCar"
            />
            <ModalConfirm
                ref="confirmDelete"
                :confirm="confirm"
                @confirmModal="onDeleteCar"
            /> 
        </b-container>
    </div>
</template>

<script>
import ModalCar from "@/components/Car/ModalCar.vue"
import carServices from "@/api/car.service.js";
import ModalConfirm from "@/components/Modal/Alert/ModalConfirm.vue";
import createDebouncedFunction from "@/util/debounce.js";
import { getCancelToken } from "@/util/axiosCancel";
import calculateIndex from "@/util/calculateIndex.js";

export default {
    components: { ModalConfirm, ModalCar },
    data() {
        return {
            isLoadPage: false,
            isLoading: false,
            calculateIndex,
            pagination: {
                currentPage: 1,
                perPage: 10,
                totalRows: 0,
            },
            searchTerm: "",
            cars: [],
            fields: [
                {
                    key: "index",
                    label: "#",
                },
                {
                    key: "plate",
                    label: "ทะเบียนรถ",
                },
                {
                    key: "drive_system",
                    label: "ประเภทรถ",
                },
                {
                    key: "driver",
                    label: "ผู้ขับ",
                },
                {
                    key: "driver_tel",
                    label: "เบอร์โทรศัพท์",
                    class: 'text-center'
                },
                {
                    key: "status",
                    label: "สถานะ"
                },
                {
                    key: "manage",
                    label: "การจัดการ",
                },
            ],
            confirm: {
                show: false,
                icon: '<i class="fas fa-times-circle text-red fa-5x"></i>',
                emphasize: "ต้องการลบรายการ",
                text: "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้",
                isLoad: false,
                id: null
            },
            form: {
                show: false,
                isLoad: false,
                car: {
                    id: null,
                    vehicleType: null,
                    vehiclePlate: null,
                    province: null,
                    brand: null,
                    yearCreate: null,
                    engineType: null,
                    engineSize: null,
                    driveSystem: null,
                    status: null
                }
            }
        }
    },
    created() {
        this.getCar();
    },
    methods: {
        onSearchInput: createDebouncedFunction(function() {
            this.getCar();
        }, 500),
        async getCar(page = 1) {
            this.isLoading = true;
            this.isLoadPage = true
            try {
                const cancelToken = getCancelToken();
                const response = await carServices.getCar({
                        page,
                        filters: this.searchTerm,
                    },
                    cancelToken
                );

                this.cars = response.data.data.items;
                this.pagination.totalRows = response.data.data.meta.totalItems;
                this.pagination.perPage = response.data.data.meta.itemsPerPage;
                this.pagination.currentPage = response.data.data.meta.currentPage;

            } catch (error) {
                console.log(error);
            } finally {
                this.isLoading = false;
                this.isLoadPage = false
            }
        },
        async onDeleteCar(){
            try{
                this.isLoadPage = true; 
                await carServices.removeCar(this.confirm.id)
                this.getCar();
                this.$refs.confirmDelete.closeModalConfirm();
            }catch (error) {}
            finally { this.isLoadPage = false }
        },
        openModalCar(){
            this.form.show = true
        },
        openModalConfirm(userId){
            this.confirm.show = true
            this.confirm.id = userId
            this.confirm.icon = '<i class="fas fa-times-circle text-red fa-5x"></i>';
            this.confirm.emphasize = "ต้องการลบรายการ";
            this.confirm.text = "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้";
        },
    },
}
</script>
